

export default function SocialLinks() {
  const socialLinks = [
    {
      id: 'twitter',
      name: 'Twitter',
      icon: '𝕏',
      href: '#',
      color: 'hover:bg-sky-500',
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: 'in',
      href: '#',
      color: 'hover:bg-blue-600',
    },
    {
      id: 'instagram',
      name: 'Instagram',
      icon: '📷',
      href: '#',
      color: 'hover:bg-pink-500',
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'f',
      href: '#',
      color: 'hover:bg-blue-500',
    },
  ]

  return (
    <div className="text-center reveal">
      <h3 className="text-xl font-bold text-white mb-6">Connect With Us</h3>
      <div className="flex justify-center gap-4">
        {socialLinks?.map((social) => (
          <a
            key={social?.id}
            href={social?.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`w-14 h-14 rounded-full border border-zinc-800 flex items-center justify-center text-white text-xl transition-all ${social?.color} hover:text-white hover:border-transparent hover:scale-110`}
            aria-label={social?.name}
          >
            {social?.icon}
          </a>
        ))}
      </div>
    </div>
  );
}